import React, { ChangeEvent, useCallback, useState } from 'react';
import { ContractFragment } from '../../../generated/graphql';
import { Dialog, Button, DialogActions, DialogContent, DialogTitle, Typography, Paper } from '@mui/material';

import { FormInput } from '../../../components/form-input';

interface ConfirmContractDialogProps {
  open: boolean;
  contract: ContractFragment;
  onSubmit?: (data: FormFields) => void;
  onClose?: () => void;
}

interface FormFields {
  signingDate: string;
}

export function ConfirmContractDialog(props: ConfirmContractDialogProps) {
  const { contract: c, onSubmit, onClose, open } = props;

  const [formData, setFormData] = useState<FormFields>({
    signingDate: c.signingDate ?? new Date().toISOString(),
  });

  const handleUpdate = useCallback(
    (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const t = e.target;
      if (t.type === 'number') {
        setFormData({ ...formData, [t.name]: parseFloat(t.value) });
      } else {
        setFormData({ ...formData, [t.name]: t.value });
      }
    },
    [formData, setFormData],
  );

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Potvrdenie zmluvy</DialogTitle>
      <DialogContent>
        <FormInput
          name="signingDate"
          label="Dátum podpisu zmluvy"
          type="date"
          value={formData.signingDate?.substring(0, 10)}
          onChange={handleUpdate}
          direction="row"
        />
        <Paper>
          <Typography variant="body2" sx={{ padding: 2 }}>
            Po potvrdení zmluvy skontrolujte, či sú všetky údaje správne.
            <br />
            Predovšetkým skontrolujte:
            <li>
              <strong>Dátum začiatku a konca trvania nájmu</strong> - v tých dátumoch bude nehnuteľnosť označená ako
              prenajatá
            </li>
            <li>
              <strong>Zoznam nájomníkov</strong> - na emailové adresy všetkých nájomníkov budú zasielané pripomienky
            </li>
          </Typography>
        </Paper>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Zatvoriť</Button>
        <Button
          onClick={() => {
            if (onSubmit) {
              onSubmit({ ...formData });
            }
          }}
          variant="contained"
        >
          Potvrdiť zmluvu
        </Button>
      </DialogActions>
    </Dialog>
  );
}
